<template>
  <b-card card>
    <b-card-header>Add Missing Items</b-card-header>
    <b-card-body>
      <div class="table-responsive mb-0">
        <b-table
            :key="items.key"
            :items="items"
            :fields="fields"
            responsive="sm"
            :filter="filter"
            :per-page="10"
            :current-page="currentPage"
        >
          <template v-slot:cell(ordered_qty)="row">
            {{row.item.quantity}}
          </template>
          <template v-slot:cell(missing_qty)="row">
            <div class="col-sm-12 col-md-4 col-lg-4">
              <b-input-group>
                <b-input-group-prepend>
                  <b-button @click="(() => row.item.missing_qty == 0 ? row.item.missing_qty : row.item.missing_qty -= 1)" size="sm"><i class="fa fa-minus"></i></b-button>
                </b-input-group-prepend>
                <b-form-input :key="row.item.id + key" readonly  min="0" v-model="row.item.missing_qty" :value="row.item.missing_qty"></b-form-input>
                <b-input-group-append>
                  <b-button @click="(() => row.item.quantity < row.item.missing_qty + 1 ? row.item.missing_qty : row.item.missing_qty += 1)" size="sm"><i class="fa fa-plus"></i></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination :key="items.key" v-model="currentPage" :total-rows="items.length" :per-page="10"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card-body>
    <b-card-footer>
      <b-button variant="success" @click="saveMissingItems">Save</b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import axios from "axios";
import {OrdersPath} from "@/path";
import Swal from "sweetalert2";

export default {
  name: "missing_items",
  props : ['selected_order'],
  data(){
    return {
      items : [],
      currentPage : 1,
      fields : ['title','ordered_qty','missing_qty'],
      filter : '',
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      key : 0
    }
  },
  mounted(){
    this.getOrderItems();
  },
  methods : {
    async getOrderItems(){
      try {
        let res = await axios.get(this.baseUrl + OrdersPath.GET_ORDER_ITEMS,{
          params : {
            order_id : this.selected_order.id
          }
        });
        if(res.data.status){
          this.items = res.data.data;
        }
      }catch (e) {
        console.log(e);
      }
    },
    async saveMissingItems(){
      try {
        let res = await axios.post(this.baseUrl + OrdersPath.SAVE_MISSING_ITEMS,{
          missing_items : this.items.map(f => {
            let res = {};
            res.id = f.id;
            res.missing_qty = f.missing_qty
            return res;
          })
        });
        if(res.data.status){
          Swal.fire("Added Missing Items","","success");
          this.$bvModal.hide('bv-missing-items');
          this.$emit('update');
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<style>

</style>